export interface GoodToKnowInfoProps {
  question: string;
  answer: string;
  analytics: string;
}

export const getGoodToKnowInfo: GoodToKnowInfoProps[] = [
  {
    question: 'How can I change the cost of my pet insurance?',
    answer:
      'With Lemonade, you can select your annual deductible, <a href="https://www.lemonade.com/pet/explained/co-insurance/">co-insurance</a>, and annual limit. This allows you to decide how much you pay in premiums and receive in future reimbursements. Lemonade also offers discounts for multiple pets, annual payments, and bundling.',
    analytics: 'how_can_i_change_the_cost_of_my_pet_insurance',
  },
  {
    question: 'How can I customize my Lemonade pet insurance policy?',
    answer:
      'We offer several <a href="https://www.lemonade.com/pet/explained/lemonades-preventative-care-options-explained/">routine care packages</a> that help cover things like vaccines and wellness visits. We also offer <a href="https://www.lemonade.com/pet/explained/lemonade-pet-add-ons/">additional coverages</a> for: Vet visit fees, physical therapy, behavioral conditions, dental illness, and end-of-life and remembrance.',
    analytics: 'how_can_i_customize_my_lemonade_pet_insurance_policy',
  },
  {
    question: 'How do pet insurance claims work?',
    answer:
      'Lemonade Pet works on a reimbursement basis. You’ll pay the vet bill up front, and then you can immediately file a claim on the Lemonade app. Just about 50% of our claims are handled instantly. Once approved, we’ll issue a reimbursement directly to your bank account, keeping in mind your deductible and co-insurance.',
    analytics: 'how_insurance_claims_work',
  },
  {
    question: 'What sets Lemonade apart from other pet insurers?',
    answer:
      'Lemonade offers a combination of customizability, affordability, and convenience that’s hard to beat. Coverages and add-ons can be tailored to your pet’s needs and your budget. Plus, you can manage your policy and file claims directly through the easy-to-use Lemonade app.',
    analytics: 'apart_from_other_pet_insurers',
  },
  {
    question: 'What are pre-existing conditions and are they covered?',
    answer:
      'Anything your pet has shown signs of before the policy’s <a href="https://www.lemonade.com/pet/explained/waiting-periods/">waiting periods</a> are up would be considered a <a href="https://www.lemonade.com/pet/explained/pet-insurance-pre-existing-conditions/">pre-existing condition.</a> But we’ve got your back in case of accidents and any new illnesses, as part of our base coverage.',
    analytics: 'pre_existing_conditions',
  },
  {
    question: 'How can I reach Lemonade customer support? ',
    answer:
      'Our warm, efficient, and compassionate customer support is available through the Lemonade app, at help@lemonade.com, and you can always chat with a real person via phone at 1-844-733-8666.',
    analytics: 'customer_support',
  },
];
